<template>
    <div>
        <file-pond
            ref="pond"
            name="file"
            :allow-multiple="allowMultiple"
            :max-files="maxFiles"
            label-idle="Drag & Drop your files or <span class='filepond--label-action'>Browse</span>"
            accepted-file-types="image/*"
            allow-image-preview="true"
            allow-image-exif-orientation="true"
            allow-file-validate-size="true"
            allow-file-validate-type="true"
            allow-image-transform="true"
            :server="serverConfig"
        />
    </div>
</template>

<script>
import vueFilePond from 'vue-filepond';

// Import plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js';

// Import styles
import 'filepond/dist/filepond.min.css';
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

// Create FilePond component
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);


export default {
    props: {
        allowMultiple: {
            type: Boolean,
            default: false,
        },
        maxFiles: {
            type: Number,
            default: 3,
        },
        serverConfig: {
            type: Object,
            default: () => ({
                url: '/api/upload', // Your API endpoint
                process: '/process',
                revert: '/revert',
            }),
        },
    },
};
</script>

<style scoped>
/* Add custom styles if needed */
</style>
